module.exports = __webpack_public_path__ + "static/images/de0fb2080a5037b30afbacc17603057d.svg";